import styled, { css } from 'styled-components';
import { layout, media, remCalc } from '@prisjakt/ui-base';
import { Tabs as TabsComponent } from '../tabs-new';
import { NAV_HEIGHT } from './constants';
import { zindex } from 'src/ui/zindex';

export const Tabs = styled(TabsComponent)<{
  mobileSearchBarVisible: boolean;
  headerIsVisible?: boolean;
  isSticky?: boolean;
  background?: boolean;
}>(p => {
  const mobileHeaderHeight = p.headerIsVisible
    ? layout.headerHeight.mobile.value
    : 0;
  const mobileSearchBarHeight = p.mobileSearchBarVisible
    ? layout.headerHeight.mobileWithSearch.value -
      layout.headerHeight.mobile.value
    : 0;

  return css`
    position: sticky;
    top: ${p.headerIsVisible ? layout.headerHeight.desktop.rem : 0};
    background: ${p.theme.bg.primary};
    z-index: ${zindex.menu.sticky.normal};
    ${p.background &&
      css`
        z-index: ${p.isSticky
          ? zindex.menu.sticky.background.isSticky
          : zindex.menu.sticky.background.default};
      `};
    height: ${`${NAV_HEIGHT}px`};

    ${media.mediumUp`
      margin: 0 ${layout.measurements.spacing050};
    `}

    ${media.smallOnly`
      top: ${remCalc(mobileHeaderHeight + mobileSearchBarHeight)};
    `};
  `;
});
